module.exports = "/assets/error_image.png?0miq0wE";